import { useState } from "react";
import { usd } from "../../utils/convertToDollerFormat";
import "./billTable.css";
import objectToArray from "../../utils/objectToArray";

export default function BillTable({
  keyVal,
  count,
  body,
  monthly,
  today,
  unlimitedBasePrice,
  total,
}) {
  let tableBody =
    body.grand_total && body.taxes
      ? objectToArray({
          full_price: body.full_price,
          tax: body.taxes,
          // total: body.grand_total,
        })
      : body;
  return (
    <div className="pricing-table">
      <table className="pricing-table-container">
        <thead>
          <tr>
            <th className={count >= 1 ? "column-one" : "total-heading hide"}>
              {count >= 1 && (
                <>
                  Item{count}
                  {/* <br />
                  <span className="number">{number}</span> */}
                </>
              )}
            </th>
            <th className={count < 1 ? "total-heading" : ""}>
              {count <= 1 && <span className="table-heading">Monthly</span>}
            </th>
            <th className={count < 1 ? "total-heading" : ""}>
              {count <= 1 && <span className="table-heading">Today</span>}
            </th>
          </tr>
        </thead>
        <tbody>
          {tableBody?.map((prod, i) => {
            return (
              (Object.entries(prod)[0][0] !== "sim_type" &&
                Object.entries(prod)[0][0] !== "finance_option_id") && (
                <tr key={Math.random() * i}>
                  <td>
                    {prod?.name
                      ? prod?.name
                      : prod?.instant_pay_tax
                      ? "Taxes"
                      : prod?.activation_charge
                      ? "Activation Fee"
                      : "Full price"}
                  </td>
                  <td>
                    {(prod?.monthly_payment_tax
                      ? usd(prod?.monthly_payment_tax)
                      : prod?.monthly_payment && usd(prod?.monthly_payment)) ||
                      "-"}
                  </td>
                  <td>
                    {prod?.instant_pay_tax
                      ? usd(prod?.instant_pay_tax)
                      : prod?.activation_charge
                      ? usd(prod.activation_charge)
                      : (prod?.instant_pay && usd(prod?.instant_pay)) || "-"}
                  </td>
                </tr>
              )
            );
          })}
        </tbody>
        {count === 0 && (
          <tfoot>
            <tr>
              <td>
                <span>Total</span>
              </td>
              <td>
                {body.grand_total && usd(body?.grand_total?.monthly_payment)}
              </td>
              <td>{body.grand_total && usd(body?.grand_total?.instant_pay)}</td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
